var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credits-layout"},[(_vm.loading)?_c('div',{staticStyle:{"text-align":"center"}},[_c('app-loader',{attrs:{"type":"primary"}})],1):_vm._e(),(!_vm.loading)?_c('div',{staticClass:"credits-page-container"},[_c('router-view')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }